// extracted by mini-css-extract-plugin
export var defImg = "image-module--defImg--FT+lg";
export var mirImg = "image-module--mirImg--X2a-C";